/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowmakevariants3Inputs */

const en_aiflowmakevariants3 = /** @type {(inputs: Aiflowmakevariants3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create 4 variants`)
};

const de_aiflowmakevariants3 = /** @type {(inputs: Aiflowmakevariants3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 Varianten erstellen`)
};

/**
* | output |
* | --- |
* | "Create 4 variants" |
*
* @param {Aiflowmakevariants3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowmakevariants3 = /** @type {((inputs?: Aiflowmakevariants3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowmakevariants3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowmakevariants3(inputs)
	return de_aiflowmakevariants3(inputs)
});
export { aiflowmakevariants3 as "aiFlowMakeVariants" }